import CreateNewAccount from './CreateNewAccount';

export default CreateNewAccount;
